import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import GlobalSpinner from "./features/CommonComponents/GlobalSpinner/GlobalSpinner";
import Wrapper from "./components/Wrapper";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Wrapper>
      <Provider store={store}>
        <GlobalSpinner appContainer={<App />}></GlobalSpinner>
      </Provider>
    </Wrapper>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
